import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaCloudUploadAlt, FaBars, FaHome , FaTimes, FaSignOutAlt, FaChartBar, FaCog} from "react-icons/fa";
import "../styles/Dashboard.css";

import useAuthService from "../hooks/useAuthService";


const Dashboard = ({ open, setOpen, userRole }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { LogoutUser } = useAuthService();

  const menuItems = [
    { path: "/", icon: <FaHome className="icon" />, label: "Home", roles: ["customer", "admin"] },
    { path: "/account", icon: <FaUser className="icon" />, label: "Account", roles: ["customer", "admin"] },
    { path: "/upload", icon: <FaCloudUploadAlt className="icon" />, label: "Files", roles: ["customer", "admin"] },
    { path: "/admin", icon: <FaChartBar className="icon" />, label: "Admin Dashboard", roles: ["admin"] },
    { path: "/settings", icon: <FaCog className="icon" />, label: "Settings", roles: ["admin"] },
];


  return (
    <>
      {/* Menu-btn */}
        <button className="menu-btn" onClick={() => setOpen(!open)}>
            {open ? <FaTimes className="icon" /> : <FaBars className="icon" />}
        </button>
      
      {/* Sidebar */}
      <div className={`sidebar ${open ? "open" : "closed"}`}>
        <ul>
          {menuItems
            .filter(item => item.roles.includes(userRole)) // Show only allowed items
            .map(item => (
                <li key={item.path} className={location.pathname === item.path ? "active" : ""}>
                    <Link to={item.path} onClick={() => setOpen(false)}>
                        {item.icon}
                        <span className={`text ${open ? "visible" : "hidden"}`}>{item.label}</span>
                    </Link>
                </li>
            ))
          }
        </ul>
        {/* Logout Button at Bottom */}
        <div className="logout">
          <button
            className="logout-btn"
            onClick={() => {
              LogoutUser(navigate);
              setOpen(false);
            }}
          >
            <FaSignOutAlt className="icon" />
            <span className="text">Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Dashboard;